module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.box_view),
      expression: "box_view"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": _vm.type,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59673d0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/readonly_text.vue
// module id = 985
// module chunks = 0